export const getRelativeCanvasPosition = (pageX: number, pageY: number, height: number) => {
  return {
    pageY: pageY + height > window.innerHeight ? window.innerHeight - height - 24 : Math.max(24, pageY),
    pageX: pageX + 248 > window.innerWidth ? window.innerWidth - 248 - 24 : Math.max(24, pageX),
  };
};
